// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.avatar-lg {
  height: 96px;
  width: 96px;
}

.drop-zone {
  border: 2px dashed transparent;
  transition: all 0.3s ease;
}

.drag-over {
  border: 2px dashed #727cf5 !important;
  background-color: rgba(114, 124, 245, 0.1) !important;
}

.drag-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(114, 124, 245, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  pointer-events: none;
}

.position-relative {
  position: relative;
}
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
